import { IDeductionDeleteDocumentsParams, IDeductionDeleteDocumentsResponse, IDeductionRepository } from "@/core/repositories/deduction";

export class DeleteDeductionDocumentsUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async execute(params: IDeductionDeleteDocumentsParams, currentPage: number): Promise<IDeductionDeleteDocumentsResponse> {
    return this.deductionRepository.deleteDeductionDocuments(params, currentPage);
  }
}
